import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { FeedCalculatorTool } from '@/components/entry/FeedCalculatorTool';

export const Route = createFileRoute('/_app/tools/feed-calculator')({
  component: FeedCalculatorPage,
});

function FeedCalculatorPage() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      {/* Back link */}
      <div className="flex items-center gap-2">
        <Link
          to="/entry"
          className="p-2 -ml-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </Link>
        <span className="text-sm text-gray-500">Back to entry checklist</span>
      </div>

      {/* Calculator */}
      <FeedCalculatorTool />

      {/* Help text */}
      <div className="text-center py-4 border-t border-gray-200">
        <p className="text-sm text-gray-500">
          Need help? Check out the{' '}
          <a href="#" className="text-cyan-600 hover:underline">
            feed calculation guide
          </a>
        </p>
      </div>
    </div>
  );
}
